import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import { getProperty } from "dot-prop";
import { useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PageListHeader from "./PageListHeader.js";
import PageListItem from "./PageListItem.js";

export default function PageList({
  extraContent,
  items,
  locales,
  pageName,
  primaryTextProp,
  searchBoxLabel,
  secondaryTextProp = "",
  sortByProp = primaryTextProp,
}) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [searchValue, setSearchValue] = useState("");
  const [isAscending, setIsAscending] = useState(true);

  const filteredItems = useMemo(() => {
    if (!items) return;

    const filtered = items.filter((item) =>
      getProperty(item, primaryTextProp)
        .toLowerCase()
        .includes(searchValue.toLowerCase())
    );

    return filtered.sort((a, b) => {
      const propA = getProperty(a, sortByProp).toLowerCase();
      const propB = getProperty(b, sortByProp).toLowerCase();

      return isAscending ? (propA > propB ? 1 : -1) : propA < propB ? 1 : -1;
    });
  }, [isAscending, items, primaryTextProp, searchValue, sortByProp]);

  const handleInput = ({ target }) => {
    setSearchValue(target.value);
  };

  const handleClearInput = () => {
    setSearchValue("");
  };

  const handleSort = () => {
    setIsAscending(!isAscending);
  };

  const handleNavigate = (item) => {
    const basePath = pathname.includes("events")
      ? pathname.replace("events", "plots")
      : pathname;

    navigate(`${basePath}/${item?.id}`, { state: { id: item.id } });
  };

  return (
    <>
      <PageListHeader
        handleClearInput={handleClearInput}
        handleInput={handleInput}
        handleSort={handleSort}
        locales={locales}
        isAscending={isAscending}
        pageName={pageName}
        searchBoxLabel={searchBoxLabel}
        searchValue={searchValue}
      />
      {filteredItems.length ? (
        <List>
          {filteredItems.map((item, index) => (
            <PageListItem
              extraContent={extraContent ? extraContent(item) : null}
              handleNavigate={handleNavigate}
              index={index}
              item={item}
              key={index}
              primaryText={item[primaryTextProp]}
              secondaryText={getProperty(item, secondaryTextProp)}
            />
          ))}
        </List>
      ) : (
        <Typography>{locales["search.empty"]}</Typography>
      )}
    </>
  );
}
